<template>
  <vs-popup class="checkout-popup-promotion" title="Promotion Detail" :active.sync="popupConfigPromotion.isOpen">
    <div class="flex justify-end">
      <vs-button class="px-4 py-2" @click="clearRadio">Clear</vs-button>
    </div>
     <div class="mt-6 background-with-theme" style="max-height: calc(100vh - 300px); overflow-y: auto; background: #fafafa; padding: 20px">
            <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(promo, index) in promoData" :key="index" :class="{'is-selected': promo.checked}">
              <template slot="no-body">
                  <label class="vs-component con-vs-radio vs-radio-primary w-full p-5">
                      <input name="radio" type="radio" class="vs-radio--input" :id="promo.id" :value="promo.id" @click="addPromotion(promo)">
                      <span class="vs-radio" :class="{'bg-primary': promo.checked}">
                          <span class="vs-radio--borde"></span>
                          <span class="vs-radio--circle" style="position: relative;">
                            <transition name="list">
                              <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px" v-show="promo.checked">check</i>
                            </transition>
                          </span>
                      </span>
                      <span class="vs-radio--label">
                          <!-- <div class="title pl-4 font-bold text-2xl py-1">{{promo.campaign.name}}</div> -->
                          <div class="content pl-4 pb-1">{{promo.campaign.name}}</div>
                      </span>
                  </label>
              </template>
            </vx-card>
             <input name="radio" id="temp-radio-promo" type="radio" hidden>
          </div>
  </vs-popup>
</template>

<script>
export default {
    name: "vs-popup-promotion",
    props:{
      popupConfigPromotion:{
        type: Object,
        required: true
      },
      promoData: {
        type: Array,
        required: true
      }
    },

    methods: {
      clearRadio(){
        this.$emit('ClearPromo');
      },
      changeStatusRadio(item) {
        for(let i = 0; i < this.promoData.length; i++) {
          if(this.promoData[i].checked) {
              // this.promoData[i].checked = false;
              this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.promoData[i]);
          }
        }
        for(let i = 0; i < this.promoData.length; i++) {
          if(this.promoData[i].id == item.id) {
              // this.promoData[i].checked = true;
              if(this.promoData[i].checked != true) {
                this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.promoData[i]);
              }
          }
        }
      },
      addPromotion(promo){
        this.changeStatusRadio(promo);
        this.$emit("AddPromotion" , promo);
      }
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.con-vs-popup
{
    &.checkout-popup-promotion {
      z-index: 999999;
        // .vs-popup {
        // }
      .is-selected {
          -webkit-transform: translate(0)!important;
          transform: translate(0)!important;
          background: rgba($primary,.05)!important;
      }

      .is-selected {
          color: rgba($primary,1);
          -webkit-box-shadow: 0 0 1px 0 rgba($primary,1)!important;
          box-shadow: 0 0 1px 0 rgba($primary,1)!important;
      }

      .list-enter,
      .list-leave-to {
          visibility: hidden;
          height: 0;
          margin: 0;
          padding: 0;
          opacity: 0;
      }

      .list-enter-active,
      .list-leave-active {
          transition: all 0.3s;
      }
    }
}
.theme-dark {
  .background-with-theme {
    background: transparent !important;
  }
}
</style>
